import { render, staticRenderFns } from "./MyPackage.vue?vue&type=template&id=6fc8fd38&scoped=true&"
import script from "./MyPackage.vue?vue&type=script&lang=js&"
export * from "./MyPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc8fd38",
  null
  
)

export default component.exports